import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle, Container } from 'components/Page';
import Loading from 'components/Loading';

const WebinarStatusPage = React.lazy(() => import('./WebinarStatus'));

function WebinarStatus(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>وضعیت سرویس وبینار</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <Container>
          <WebinarStatusPage />
        </Container>
      </Suspense>
    </Page>
  );
}

export default WebinarStatus;
